import { IPackagesBookState } from "./state";

export const getUserPassengers = (state: {
  packagesBook: IPackagesBookState;
}) => state.packagesBook.userPassengers;

export const getUserPassengersCallState = (state: {
  packagesBook: IPackagesBookState;
}) => state.packagesBook.userPassengerCallState;
